
import React, { useEffect, useState, useRef } from "react";
import { usePaymentDropdowns } from "../../hooks/usePaymentDropdowns";
import { Row, Col, Card, Button, Divider, Typography, notification, Drawer, Space, Form, Input, InputNumber, Select, Upload, Checkbox, DatePicker, Modal, message, Avatar, Flex, Switch, Alert, Badge, Tooltip, AutoComplete } from "antd";
import axios from "axios";
import { useHistory, useParams } from "react-router-dom";
import { baseUrl } from "../../config";
import { PlusOutlined, UploadOutlined, CloseOutlined, UserOutlined, FacebookOutlined, InstagramOutlined, TwitterOutlined, PhoneOutlined, MailOutlined, CalendarOutlined, HomeOutlined, MoneyCollectOutlined, SearchOutlined, SwapOutlined, EditOutlined, SaveOutlined, CheckCircleOutlined, ExclamationCircleOutlined, TeamOutlined } from '@ant-design/icons';
import '../../assets/styles/custom_style.css';
import UserModalContent from './UserModalContent';
import AddUserDetailsModel from './AddUserDetailsModel';
import moment from 'moment';
import _ from 'lodash';
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";

const { Title, Text } = Typography;
const { Item } = Form;
const { Option } = Select;
const { MonthPicker, RangePicker } = DatePicker;

const EDIT_REVERSE_RELATION = {
    "सुपुत्र श्री":    "Son of Mr.",
    "सुपुत्री श्री":   "Daughter of Mr.",
    "पत्नी श्री":      "Wife of Mr.",
    "पत्‍नी श्री":     "Wife of Mr.",
    "गोद पुत्र श्री":  "Adopted Son of Mr.",
    "शिष्य श्री":      "Disciple of Mr.",
    "व्यवसाय/अन्य":    "Business/Other",
};

function PaymentsEditForm({ isDrawerMode = false, onSuccess, onClose, id: propId }) {
    const { bankAccounts, specialOccasions } = usePaymentDropdowns();
    const { id: paramId } = useParams();
    const id = isDrawerMode ? propId : paramId;
    const location = useLocation();
    // const { id } = useParams();
    const history = useHistory();
    const [form] = Form.useForm();
    const [isUpdateMode, setIsUpdateMode] = useState(false);
    const [imageUrl, setImageUrl] = useState(null);
    const [file, setFile] = useState(null);
    const [userBasicDetail, setuserBasicDetail] = useState({});
    const [userId, setUserId] = useState(null);
    
    const [transactionDate, setTransactionDate] = useState();
    const [selectedBankAccount, setSelectedBankAccount] = useState('');
    const [showSpecialOccassionCategory, setSpecialOccassionCategory] = useState(false);
    const [showCategoryPay, setCategoryPay] = useState(true);
    const [paidMonths, setPaidMonths] = useState([]);
    const [showMonthCoverd, setshowMonthCoverd] = useState(true);
    const { page } = location.state || {};
    const [ereciept_date, setErecipt_date] = useState();
    const [showEReceiptFields, setShowEReceiptFields] = useState(false);
    const [showGatewayFields, setShowGatewayFields] = useState(false);
    const [currentStartMonth, setCurrentStartMonth] = useState();
    const [currentEndMonth, setCurrentEndMonth] = useState();
    const [isBankAccountDisabled, setIsBankAccountDisabled] = useState(false);
    const [utrSuggestion, setUtrSuggestion] = useState([]);

    const [isShopDonation, setIsShopDonation] = useState(false);

    // Transfer functionality states
    const [isTransferMode, setIsTransferMode] = useState(false);
    const [newPhoneNumber, setNewPhoneNumber] = useState('');
    const [newUserId, setNewUserId] = useState(null);
    const [newUserData, setNewUserData] = useState(null);
    const [familyMembers, setFamilyMembers] = useState([]);
    const [countryCode, setCountryCode] = useState('91');
    const [originalUserData, setOriginalUserData] = useState(null);
    const [currentPage, setCurrentPage] = useState(1); // Add this state
    const [limit, setLimit] = useState(20); // Add this state

    // useEffect(() => {
    //     if (id) {
    //         setIsUpdateMode(true);
    //         fetchUserDetails();
    //     }
    // }, [id]);

    useEffect(() => {
    if (id) {
        setIsUpdateMode(true);
        fetchUserDetails();
    }
}, [id]);

    useEffect(() => {
        const userId = localStorage.getItem('userId');
        if (userId === '71') {
            setIsBankAccountDisabled(true);
        } else {
            setIsBankAccountDisabled(false);
        }
    }, [form]);

    const fetchUserDetails = async () => {
        try {
            const response = await axios.get(`${baseUrl}/payments/read/${id}`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
                },
            });
            if (response.status === 200) {
                const userData = response.data.result;
                const months = await getPaidMonths(userData.user_id, id);
                setUserId(userData.user_id);
                setTransactionDate(userData.transaction_date ? userData.transaction_date : null);
                setErecipt_date(userData.e_reciept_date ? userData.e_reciept_date : null);

                // Store original user data for transfer comparison
                setOriginalUserData({
                    user_id: userData.user_id,
                    phone_no: userData.phone_no,
                    name_eng: userData.name_eng,
                    father_name_en: userData.father_name_en,
                    relation_en: userData.relation_en,
                    name_hn: userData.name_hn,
                    father_name_hn: userData.father_name_hn,
                    relation_hn: userData.relation_hn
                });

                const eReceiptPaymentModes = ['Cash', 'Website-Razorpay', 'Application-Razorpay', 'Registration-Rozapay'];
                if (eReceiptPaymentModes.includes(userData?.pyament_mode_type)) {
                    setShowEReceiptFields(true);
                }
                const mode = userData?.pyament_mode_type || '';
                if (mode.toLowerCase().includes('razorpay') || mode.toLowerCase().includes('rozapay')) {
                    setShowGatewayFields(true);
                }

                userData.payment_entry_date = userData.payment_entry_date ? moment(userData.payment_entry_date) : null;
                if (userData.start_month) {
                    userData.month_range = [
                        moment(userData.start_month),
                        moment(userData.end_month)
                    ]
                }
                userData.start_month = userData.start_month ? moment(userData.start_month) : null;
                userData.end_month = userData.end_month ? moment(userData.end_month) : null;
                setCurrentStartMonth(userData.start_month);
                setCurrentEndMonth(userData.end_month);

                if (userData.profile_img) {
                    setImageUrl(userData.profile_img);
                }

                setIsShopDonation(
                    userData.relation_en === 'Business/Other' || userData.relation_hn === 'व्यवसाय/अन्य'
                );

                const isSpecialOccassion = userData.is_special_occassion;
                setSpecialOccassionCategory(isSpecialOccassion === 0 || isSpecialOccassion === null ? false : true);
                setCategoryPay(isSpecialOccassion === 1 ? false : true);

                const bankAccountStr = userData.bank_account ? userData.bank_account.toString() : '';
                setSelectedBankAccount(bankAccountStr);

                // Set month coverage visibility based on bank account and special occasion status
                if (bankAccountStr === '1' && (isSpecialOccassion === 0 || isSpecialOccassion === null)) {
                    setshowMonthCoverd(true);
                } else {
                    setshowMonthCoverd(false);
                }

                // For Member-Portal Razorpay payments: if DB gateway columns are null,
                // parse them from the comment field (auto-created by webhook stores fee info there).
                if (!userData.razorpay_fee && userData.comment) {
                    const rzpMatch = userData.comment.match(/Razorpay:\s*₹([\d.]+)/);
                    const gstMatch = userData.comment.match(/GST:\s*₹([\d.]+)/);
                    const netMatch = userData.comment.match(/Net received:\s*₹([\d.]+)/);
                    if (rzpMatch) userData.razorpay_fee = parseFloat(rzpMatch[1]);
                    if (gstMatch) userData.razorpay_gst = parseFloat(gstMatch[1]);
                    if (netMatch) userData.net_amount   = parseFloat(netMatch[1]);
                }

                if (userData.relation_en && EDIT_REVERSE_RELATION[userData.relation_en]) {
                    userData.relation_en = EDIT_REVERSE_RELATION[userData.relation_en];
                }
                form.setFieldsValue(userData);
            } else {
                notification.info({
                    message: 'Info',
                    description: response.data.message,
                    placement: 'topRight'
                });
            }
        } catch (error) {
            console.error("API error:", error);
            notification.info({
                message: 'Info',
                description: error.response?.data?.message,
                placement: 'topRight'
            });
        }
    };

    // Transfer functionality methods
    const handleTransferModeToggle = () => {
        setIsTransferMode(!isTransferMode);
        if (!isTransferMode) {
            // Entering transfer mode
            setNewPhoneNumber('');
            setNewUserId(null);
            setNewUserData(null);
            setFamilyMembers([]);
        } else {
            // Exiting transfer mode - restore original data
            if (originalUserData) {
                form.setFieldsValue({
                    phone_no: originalUserData.phone_no,
                    name_eng: originalUserData.name_eng,
                    father_name_en: originalUserData.father_name_en,
                    relation_en: originalUserData.relation_en,
                    name_hn: originalUserData.name_hn,
                    father_name_hn: originalUserData.father_name_hn,
                    relation_hn: originalUserData.relation_hn
                });
                setUserId(originalUserData.user_id);
            }
        }
    };

    const handleNewPhoneNumberChange = async (e) => {
        const value = e.target.value;
        if (/^\d{0,12}$/.test(value)) {
            setNewPhoneNumber(value);
            if (value.length >= 10) {
                await checkNewUserPhone(value);
            } else {
                clearNewUserData();
            }
        }
    };

    const clearNewUserData = () => {
        setNewUserId(null);
        setNewUserData(null);
        setFamilyMembers([]);
        setPaidMonths([]);
        form.setFieldsValue({
            name_eng: '',
            father_name_en: '',
            relation_en: '',
            name_hn: '',
            father_name_hn: '',
            relation_hn: ''
        });
    };

    const checkNewUserPhone = async (phone) => {
        try {
            const response = await axios.post(
                `${baseUrl}/payments/checkUserPhone`,
                { phone_no: phone },
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
                    },
                }
            );
            
            if (response.status === 200 && response.data.exists) {
                const userData = response.data.details;
                const children = response.data.children || [];

                if (children.length > 0) {
                    // Multiple family members — let user pick the right one
                    const members = [userData, ...children];
                    setFamilyMembers(members);
                    setNewUserId(null);
                    setNewUserData(null);
                    form.setFieldsValue({ phone_no: phone, name_eng: '', father_name_en: '', relation_en: '' });
                    notification.info({
                        message: 'Family Members Found',
                        description: `${members.length} members found. Please select the correct member below.`,
                        placement: 'topRight'
                    });
                } else {
                    setFamilyMembers([]);
                    setNewUserId(userData.user_id);
                    setNewUserData(userData);
                    await getPaidMonths(userData.user_id, id);
                    form.setFieldsValue({
                        phone_no: phone,
                        name_eng: userData.name_eng,
                        father_name_en: userData.father_name_en,
                        relation_en: EDIT_REVERSE_RELATION[userData.relation_en] || userData.relation_en,
                        name_hn: userData.name_hn,
                        father_name_hn: userData.father_name_hn,
                        relation_hn: userData.relation_hn
                    });
                    notification.success({
                        message: 'User Found',
                        description: `Payment will be transferred to: ${userData.name_eng}`,
                        placement: 'topRight'
                    });
                }
            } else {
                clearNewUserData();
                notification.warning({
                    message: 'User Not Found',
                    description: 'No existing user found with this phone number. Please use an existing user for transfer.',
                    placement: 'topRight'
                });
            }
        } catch (error) {
            console.error('Error checking phone number:', error);
            message.error('Error checking phone number');
            clearNewUserData();
        }
    };

    const handleFamilyMemberSelect = async (memberId) => {
        const member = familyMembers.find(m => String(m.user_id) === String(memberId));
        if (!member) return;
        setNewUserId(member.user_id);
        setNewUserData(member);
        await getPaidMonths(member.user_id, id);
        form.setFieldsValue({
            name_eng: member.name_eng,
            father_name_en: member.father_name_en || '',
            relation_en: member.relation_en || '',
            name_hn: member.name_hn || '',
            father_name_hn: member.father_name_hn || '',
            relation_hn: member.relation_hn || ''
        });
    };

    const handleTransferWithinFamily = async () => {
        if (!originalUserData?.phone_no) return;
        setIsTransferMode(true);
        setNewPhoneNumber(originalUserData.phone_no);
        form.setFieldsValue({ phone_no: originalUserData.phone_no });
        await checkNewUserPhone(originalUserData.phone_no);
    };

const submitPaymentValues = async (values, transferring) => {
    try {
        const bankAccountValue = accountOptions[values.bank_account];
        if (bankAccountValue) {
            values.bank_account = bankAccountValue;
        }

        if (transactionDate) {
            values.transaction_date = moment(transactionDate).format('YYYY-MM-DD');
        } else {
            values.transaction_date = '';
        }

        if (ereciept_date) {
            values.ereciept_date = moment(ereciept_date).format('YYYY-MM-DD');
        } else {
            values.ereciept_date = '';
        }

        const response = await axios.patch(`${baseUrl}/payments/update/${id}`, values, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
            },
        });

        if (response.status === 200) {
            const successMessage = transferring
                ? `Payment transferred successfully to ${newUserData?.name_eng}!`
                : 'Payment updated successfully!';

            if (isDrawerMode) {
                if (typeof onSuccess === 'function') {
                    onSuccess();
                }
            } else {
                notification.success({
                    message: 'Success',
                    description: successMessage,
                    placement: 'topRight',
                    duration: 1.5
                });
                history.push({
                    pathname: '/payments',
                    state: { page: currentPage, limit: limit }
                });
            }
        } else {
            notification.info({
                message: 'Info',
                description: response.data.message,
                placement: 'topRight'
            });
        }
    } catch (error) {
        console.error("API error:", error);
        notification.error({
            message: 'Error',
            description: error.response?.data?.message || 'Failed to update payment',
            placement: 'topRight'
        });
    }
};

const onFinish = (values) => {
    values.is_special_occassion = showSpecialOccassionCategory ? 1 : 0;

    // If in transfer mode, use the new user ID
    if (isTransferMode && newUserId) {
        values.user_id = newUserId;
        values.phone_no = newPhoneNumber;
        // Carry Hindi fields from the new user
        if (newUserData) {
            values.name_hn = newUserData.name_hn || null;
            values.relation_hn = newUserData.relation_hn || null;
            values.father_name_hn = newUserData.father_name_hn || null;
        }
        // Mark as transfer in payload so backend can record audit trail
        values.is_transfer = 1;
        values.transferred_from_user_id = originalUserData?.user_id || userId;

        // Show confirmation before executing transfer
        Modal.confirm({
            title: 'Confirm Payment Transfer',
            icon: <ExclamationCircleOutlined style={{ color: '#fa8c16' }} />,
            content: (
                <div>
                    <p>Are you sure you want to transfer this payment?</p>
                    <p><strong>From:</strong> {originalUserData?.name_eng || 'Current user'}</p>
                    <p><strong>To:</strong> {newUserData?.name_eng} ({newPhoneNumber})</p>
                    <p style={{ color: '#ff4d4f', marginTop: 8 }}>
                        This action will reassign the payment record. Once transferred, the payment will appear under the new member's history.
                    </p>
                </div>
            ),
            okText: 'Yes, Transfer',
            okButtonProps: { style: { backgroundColor: '#ff4d4f', borderColor: '#ff4d4f' } },
            cancelText: 'Cancel',
            onOk: () => submitPaymentValues(values, true),
        });
    } else {
        values.user_id = userId;
        values.is_transfer = 0;
        // Hindi fields are not shown in the form — restore from original data so they are not cleared
        // Exception: if relation was changed (e.g. to Business/Other), use the new mapped Hindi value
        if (originalUserData) {
            const currentRelationEn = form.getFieldValue('relation_en');
            const relationChanged = currentRelationEn && currentRelationEn !== originalUserData.relation_en;
            values.name_hn = originalUserData.name_hn || null;
            if (relationChanged) {
                values.relation_hn = relationMapping[currentRelationEn] || currentRelationEn;
                values.father_name_hn = isShopDonation ? '' : (originalUserData.father_name_hn || null);
            } else {
                values.relation_hn = originalUserData.relation_hn || null;
                values.father_name_hn = originalUserData.father_name_hn || null;
            }
        }
        submitPaymentValues(values, false);
    }
};

    const getPaidMonths = async (userId, id) => {
        if (userId) {
            const response = await axios.get(
                `${baseUrl}/payments/overlap-check?userId=${userId}&paymentId=${id}`,
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
                    },
                }
            );
            if (response.status === 200) {
                const paidMonths = response.data.result.map(date => moment(date, 'YYYY-MM-DD').add(15, 'days'));
                setPaidMonths(paidMonths);

                if (response.data?.today?.length > 0) {
                    // message.error("Today date payment already exit.");
                }
            }
        }
    };

    const handlePaymentTypeChange = async (value) => {
        setSelectedBankAccount(value);
        if (value === '1' && !showSpecialOccassionCategory) {
            setshowMonthCoverd(true);
        } else {
            setshowMonthCoverd(false);
        }
    };

    const handleSpecialOccassionCategory = (e) => {
        const isChecked = e.target.checked;
        setSpecialOccassionCategory(isChecked);
        setCategoryPay(!isChecked);
        
        // Update month coverage visibility based on special occasion and bank account
        if (selectedBankAccount === '1' && !isChecked) {
            setshowMonthCoverd(true);
        } else {
            setshowMonthCoverd(false);
        }
    };

    const handleCountryCodeChange = (value) => {
        setCountryCode(value);
        form.setFieldsValue({ country_code: value });
    };

    const relationMapping = {
        "Son of Mr.": "सुपुत्र श्री",
        "Daughter of Mr.": "सुपुत्री श्री",
        "Wife of Mr.": "पत्नी श्री",
        "Adopted Son of Mr.": "गोद पुत्र श्री",
        "Disciple of Mr.": "शिष्य श्री",
        "Business/Other": "व्यवसाय/अन्य"
    };

    const handleRelationChange = (value) => {
        const hindiValue = relationMapping[value];
        const isShop = value === 'Business/Other';
        setIsShopDonation(isShop);
        form.setFieldsValue({
            relation_en: value,
            relation_hn: hindiValue,
            ...(isShop ? { father_name_en: '', father_name_hn: '' } : {})
        });
    };

    const monthCellRender = (date) => {
        const isPaid = paidMonths.some(
            (paidMonth) => paidMonth.year() === date.year() && paidMonth.month() === date.month()
        );
        const isCurrentMonth = (
            (date.isSame(currentStartMonth, 'month') || date.isSame(currentEndMonth, 'month')) ||
            (date.isAfter(currentStartMonth, 'month') && date.isBefore(currentEndMonth, 'month'))
        );

        return (
            <div 
                style={{
                    backgroundColor: isPaid ? '#d4edda' : isCurrentMonth ? '#fff3cd' : '',
                    color: isPaid ? 'green' : isCurrentMonth ? 'orange' : 'inherit',
                    cursor: isPaid ? 'not-allowed' : 'pointer'
                }}
            >
                {date.format('MMM')}
            </div>
        );
    };

    const disabledDate = (current) => {
        return paidMonths.some(
            (paidMonth) => current.year() === paidMonth.year() && current.month() === paidMonth.month()
        );
    };

    const countryCodes = [
        "91", "93", "355", "213", "376", "244", "54", "374", "297", "247", "61", "43", "994",
        "973", "880", "375", "32", "501", "229", "1441", "975", "591", "387", "267",
        "55", "1,284", "673", "359", "226", "95", "257", "855", "237", "1", "238",
        "1,345", "236", "235", "56", "86", "61", "61", "57", "269", "242", "682",
        "506", "385", "53", "357", "420", "243", "45", "246", "253", "1,767", "593",
        "20", "503", "240", "291", "372", "251", "500", "298", "679", "358", "33",
        "594", "689", "241", "220", "995", "49", "233", "350", "30", "299", "1,473",
        "590", "1671", "502", "224", "245", "592", "509", "39", "504", "852", "36",
        "354", "62", "98", "964", "353", "44", "972", "39", "225", "1,876",
        "81", "44", "962", "7", "254", "686", "965", "996", "856", "371", "961",
        "266", "231", "218", "423", "370", "352", "853", "389", "261", "265", "60",
        "960", "223", "356", "692", "596", "222", "230", "262", "52", "691", "373",
        "377", "976", "382", "1,664", "212", "258", "264", "674", "977", "31", "599",
        "687", "64", "505", "227", "234", "683", "672", "850", "1670", "47", "968",
        "92", "680", "970", "507", "675", "595", "51", "63", "870", "48", "351",
        "974", "242", "262", "40", "7", "250", "590", "290", "1869", "1,758", "590",
        "508", "1,784", "685", "378", "239", "966", "221", "381", "248", "232", "65",
        "1,721", "421", "386", "677", "252", "27", "82", "211", "34", "94", "249",
        "597", "47", "268", "46", "41", "963", "886", "992", "255", "66", "670",
        "228", "690", "676", "1868", "216", "90", "993", "1,649", "688", "256",
        "380", "971", "44", "1", "598", "1340", "998", "678", "58", "84", "681",
        "212", "967", "260", "263"
    ];

    const handleReciptDateChange = (date, dateString) => {
        if (date) {
            const formattedDate = moment(date).format('YYYY-MM-DD');
            setErecipt_date(formattedDate);
            form.setFieldsValue({ erecipt_date: date });
        } else {
            setErecipt_date(null);
            form.setFieldsValue({ erecipt_date: null });
        }
    };

    const handlePaymentModeChange = (value) => {
        const modesToShow = ['Cash', 'Website-Razorpay', 'Application-Razorpay', 'Registration-Rozapay'];
        setShowEReceiptFields(modesToShow.includes(value));
        const isGateway = (value || '').toLowerCase().includes('razorpay') || (value || '').toLowerCase().includes('rozapay');
        setShowGatewayFields(isGateway);
        if (!isGateway) {
            form.setFieldsValue({ razorpay_fee: null, razorpay_gst: null, net_amount: null });
        }
    };

    const checkUtrDuplicate = async (searchText) => {
        const sanitized = (searchText || '').replace(/\s+/g, '');
        if (sanitized.length < 3) {
            setUtrSuggestion([]);
            return;
        }
        try {
            const response = await axios.get(`${baseUrl}/payments/getSuggestionValue/`, {
                params: { q: sanitized, column: 'utr_number', table: 'sn_payments' },
                headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
            });
            if (response.status === 200) {
                setUtrSuggestion(response.data.result || []);
            }
        } catch (error) {
            console.error('UTR duplicate check error:', error);
        }
    };

    const handleDateChange = (date, dateString) => {
        if (date) {
            const formattedDate = moment(date).format('YYYY-MM-DD');
            setTransactionDate(formattedDate);
        } else {
            setTransactionDate(null);
        }
    };

    const accountOptions = {
        'ABRSVS(SHIKSHA NIDHI)-9078(SBI)': '1',
        'ABRSVS(M_GAUSHALA)-4937(SBI)': '2',
        'ABRSVS(ENVIRONMENT)-9598(AXIX)': '3',
        'SKSS_BADLI(80G)': '4',
        'SSS(80G)': '5',
        'Any-Other': '6',
    };

    return (
        <div style={{ display: 'flex', flexDirection: 'column', height: '100%', background: '#fff' }}>

            {/* ── Drawer Header ── */}
            <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '0 20px',
                height: 56,
                background: '#1e3a5f',
                flexShrink: 0
            }}>
                {/* Left: title + ID */}
                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                    <span style={{ color: '#fff', fontWeight: 700, fontSize: 17 }}>
                        {isUpdateMode ? 'Update Payment' : 'Add Payment'}
                    </span>
                    <span style={{
                        background: '#52c41a', color: '#fff',
                        fontSize: 11, fontWeight: 600,
                        padding: '2px 8px', borderRadius: 10
                    }}>
                        ID: {id}
                    </span>
                    {isTransferMode && (
                        <span style={{
                            background: '#ff4d4f', color: '#fff',
                            fontSize: 11, fontWeight: 600,
                            padding: '2px 8px', borderRadius: 10
                        }}>
                            TRANSFER MODE
                        </span>
                    )}
                </div>

                {/* Right: Transfer + Close */}
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    {!isTransferMode && (
                        <Tooltip title="Transfer to another member in the same family">
                            <Button
                                icon={<TeamOutlined />}
                                onClick={handleTransferWithinFamily}
                                size="small"
                                style={{ backgroundColor: 'rgba(255,255,255,0.15)', borderColor: 'rgba(255,255,255,0.3)', color: '#fff' }}
                            >
                                Family Transfer
                            </Button>
                        </Tooltip>
                    )}
                    <Tooltip title={isTransferMode ? 'Exit transfer mode' : 'Transfer this payment to another user'}>
                        <Button
                            icon={<SwapOutlined />}
                            onClick={handleTransferModeToggle}
                            size="small"
                            style={isTransferMode ? {
                                backgroundColor: '#ff4d4f', borderColor: '#ff4d4f', color: '#fff'
                            } : {
                                backgroundColor: 'rgba(255,255,255,0.15)', borderColor: 'rgba(255,255,255,0.3)', color: '#fff'
                            }}
                        >
                            {isTransferMode ? 'Exit Transfer' : 'Transfer Payment'}
                        </Button>
                    </Tooltip>
                    {isDrawerMode && (
                        <Button
                            icon={<CloseOutlined />}
                            onClick={onClose}
                            size="small"
                            style={{ backgroundColor: 'rgba(255,255,255,0.15)', borderColor: 'rgba(255,255,255,0.3)', color: '#fff' }}
                        />
                    )}
                </div>
            </div>

            {/* ── Scrollable content ── */}
            <div style={{ flex: 1, overflowY: 'auto' }}>
                    <Card
                        bordered={false}
                        style={{ borderRadius: 0, boxShadow: 'none' }}
                        bodyStyle={{ padding: 0 }}
                    >
                        {isTransferMode && (
                            <>
                            <Alert
                                message={
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                        <SwapOutlined style={{ color: '#fa8c16' }} />
                                        <strong>Transfer Mode Active</strong>
                                    </div>
                                }
                                description="Search for a new phone number to transfer to another user, or use Family Transfer to pick a member from the same family."
                                type="warning"
                                showIcon
                                style={{ borderRadius: '2px', border: '1px solid #ffd666' }}
                                icon={<ExclamationCircleOutlined />}
                            />
                            {familyMembers.length > 0 && (
                                <div style={{ backgroundColor: '#f0f5ff', border: '1px solid #adc6ff', borderTop: 'none', padding: '12px 16px' }}>
                                    <div style={{ fontSize: 12, fontWeight: 600, color: '#2f54eb', marginBottom: 8 }}>
                                        <TeamOutlined style={{ marginRight: 6 }} />
                                        Select Family Member to Transfer To:
                                    </div>
                                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
                                        {familyMembers.map(m => (
                                            <Button
                                                key={m.user_id}
                                                size="small"
                                                type={newUserId === m.user_id ? 'primary' : 'default'}
                                                disabled={m.user_id === originalUserData?.user_id}
                                                onClick={() => handleFamilyMemberSelect(m.user_id)}
                                                style={m.user_id === originalUserData?.user_id ? { opacity: 0.5, cursor: 'not-allowed' } : {}}
                                            >
                                                {m.name_hn || m.name_eng}
                                                {m.user_id === originalUserData?.user_id && ' (Current)'}
                                            </Button>
                                        ))}
                                    </div>
                                    {newUserId && newUserId !== originalUserData?.user_id && (
                                        <div style={{ marginTop: 8, fontSize: 12, color: '#52c41a' }}>
                                            <CheckCircleOutlined style={{ marginRight: 4 }} />
                                            Selected: <strong>{newUserData?.name_hn || newUserData?.name_eng}</strong>
                                        </div>
                                    )}
                                </div>
                            )}
                            </>
                        )}

                        <Form
                            form={form}
                            onFinish={onFinish}
                            layout="vertical"
                            initialValues={{ bank_account: selectedBankAccount }}
                        >
                            {/* ── Scrollable body ── */}
                            <div style={{ padding: '20px 24px' }}>

                            {/* ── MEMBER DETAILS ── */}
                            <div style={{ fontSize: 11, fontWeight: 700, color: '#8c8c8c', letterSpacing: 1.2, marginBottom: 14 }}>MEMBER DETAILS</div>

                            <Row gutter={[16, 0]}>
                                <Col xs={24} sm={14} lg={12}>
                                    <Item
                                        label="Phone Number"
                                        name="phone_no"
                                        rules={[
                                            { required: true, message: 'Please enter phone no' },
                                            { pattern: /^\d{10,12}$/, message: 'Phone no must be between 10 and 12 digits!' }
                                        ]}
                                    >
                                        <Input
                                            readOnly={!isTransferMode}
                                            onChange={isTransferMode ? handleNewPhoneNumberChange : undefined}
                                            placeholder="Phone number"
                                            prefix={<PhoneOutlined style={{ color: '#bfbfbf' }} />}
                                            addonBefore={
                                                <Select defaultValue={countryCode} onChange={handleCountryCodeChange} style={{ width: 70 }} disabled={!isTransferMode}>
                                                    {countryCodes.map(code => <Option key={code} value={code}>+{code}</Option>)}
                                                </Select>
                                            }
                                            style={isTransferMode ? { borderColor: '#ff4d4f' } : {}}
                                        />
                                    </Item>
                                </Col>
                            </Row>

                            {/* English info — Name | Relation | Father in one row */}
                            <Row gutter={[12, 0]}>
                                <Col xs={24} sm={9}>
                                    <Item label={isShopDonation ? "Business / Shop Name" : "Name (English)"} name="name_eng" rules={[{ required: true, message: 'Please enter name' }]}>
                                        <Input
                                            placeholder={isShopDonation ? "Business / Shop name" : "Full name"}
                                            readOnly
                                            prefix={<UserOutlined style={{ color: '#bfbfbf' }} />}
                                            style={isTransferMode && newUserData ? { backgroundColor: '#f6ffed', borderColor: '#52c41a' } : { backgroundColor: '#fafafa' }}
                                        />
                                    </Item>
                                </Col>
                                <Col xs={24} sm={isShopDonation ? 15 : 5}>
                                    <Item label="Relation" name="relation_en">
                                        <Select placeholder="Relation" onChange={handleRelationChange}>
                                            <Option value="Son of Mr.">Son of Mr.</Option>
                                            <Option value="Daughter of Mr.">Daughter of Mr.</Option>
                                            <Option value="Wife of Mr.">Wife of Mr.</Option>
                                            <Option value="Adopted Son of Mr.">Adopted Son of Mr.</Option>
                                            <Option value="Disciple of Mr.">Disciple of Mr.</Option>
                                            <Option value="Business/Other">Business/Other</Option>
                                        </Select>
                                    </Item>
                                </Col>
                                {!isShopDonation && (
                                <Col xs={24} sm={10}>
                                    <Item label="Father / Husband" name="father_name_en">
                                        <Input
                                            placeholder="Father / Husband name"
                                            readOnly
                                            prefix={<UserOutlined style={{ color: '#bfbfbf' }} />}
                                            style={isTransferMode && newUserData ? { backgroundColor: '#f6ffed', borderColor: '#52c41a' } : { backgroundColor: '#fafafa' }}
                                        />
                                    </Item>
                                </Col>
                                )}
                                {isShopDonation && (
                                <>
                                    <Item name="father_name_en" hidden><Input /></Item>
                                    <Item name="father_name_hn" hidden><Input /></Item>
                                </>
                                )}
                            </Row>


                            <Divider style={{ margin: '4px 0 20px' }} />

                            {/* ── PAYMENT DETAILS ── */}
                            <div style={{ fontSize: 11, fontWeight: 700, color: '#8c8c8c', letterSpacing: 1.2, marginBottom: 14 }}>PAYMENT DETAILS</div>

                            <Row gutter={[16, 0]}>
                                <Col xs={24} sm={12}>
                                    <Item label="Account" name="bank_account" rules={[{ required: true, message: 'Select Bank Account' }]}>
                                        <Select onChange={handlePaymentTypeChange} placeholder="Select Account" defaultValue={selectedBankAccount} disabled={isBankAccountDisabled}>
                                            {bankAccounts.map(acc => (
                                                <Option key={acc.id} value={String(acc.id)}>{acc.account_name}</Option>
                                            ))}
                                        </Select>
                                    </Item>
                                </Col>
                                <Col xs={24} sm={12}>
                                    <Item label="Special Occasion / Suspense">
                                        <div style={{ padding: '7px 11px', border: '1px solid #d9d9d9', borderRadius: 6, background: '#fafafa', height: 32, display: 'flex', alignItems: 'center' }}>
                                            <Checkbox checked={showSpecialOccassionCategory} onChange={handleSpecialOccassionCategory}>
                                                Special Occasion / Suspense Entry
                                            </Checkbox>
                                        </div>
                                    </Item>
                                </Col>
                            </Row>

                            {showSpecialOccassionCategory && (
                                <Row gutter={[16, 0]}>
                                    <Col xs={24} sm={12}>
                                        <Item label="Special Occasion Type" name="special_occassion_category" rules={[{ required: true, message: 'Select Special Occasion' }]}>
                                            <Select placeholder="Select Special Occasion" showSearch allowClear filterOption={(input, option) => (option?.children ?? '').toLowerCase().includes(input.toLowerCase())}>
                                                {specialOccasions.map(opt => (
                                                    <Option key={opt.id} value={opt.category_name}>{opt.category_name}</Option>
                                                ))}
                                            </Select>
                                        </Item>
                                    </Col>
                                </Row>
                            )}

                            <Row gutter={[16, 0]}>
                                <Col xs={24} sm={12}>
                                    <Item label="Amount (₹)" name="amount" rules={[{ required: true, message: 'Please enter amount' }]}>
                                        <InputNumber
                                            className="input_number_type"
                                            placeholder="Enter Amount"
                                            style={{ width: '100%', fontWeight: 600 }}
                                            min={0}
                                            formatter={value => `₹ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                            parser={value => value.replace(/₹\s?|(,*)/g, '')}
                                        />
                                    </Item>
                                </Col>
                                <Col xs={24} sm={12}>
                                    <Item label="Transaction ID (UTR / ID)" name="utr_number">
                                        <AutoComplete
                                            placeholder="Enter UTR / Transaction ID"
                                            options={utrSuggestion}
                                            status={utrSuggestion.length > 0 ? "warning" : ""}
                                            style={{ fontFamily: 'monospace', width: '100%' }}
                                            onChange={(value) => {
                                                form.setFieldsValue({ utr_number: (value || '').replace(/\s+/g, '') });
                                                checkUtrDuplicate(value);
                                            }}
                                        />
                                    </Item>
                                    {utrSuggestion.length > 0 && (
                                        <div style={{ marginTop: -8, marginBottom: 8, padding: '6px 10px', background: '#fffbe6', border: '1px solid #faad14', borderRadius: 6, fontSize: 12 }}>
                                            <span style={{ fontWeight: 700, color: '#d48806' }}>ℹ UTR already used — entry still allowed: </span>
                                            <span style={{ color: '#333' }}>{utrSuggestion[0].name} / {utrSuggestion[0].phone_no}</span>
                                        </div>
                                    )}
                                </Col>
                            </Row>

                            <Row gutter={[16, 0]}>
                                <Col xs={24} sm={12}>
                                    <Item label="Transaction Date">
                                        <DatePicker
                                            onChange={handleDateChange}
                                            value={transactionDate && moment(transactionDate)}
                                            className="filter_dob"
                                            format="DD-MM-YYYY"
                                            placeholder="Select Transaction Date"
                                            style={{ width: '100%' }}
                                        />
                                    </Item>
                                </Col>
                                <Col xs={24} sm={12}>
                                    <Item label="Payment Mode" name="pyament_mode_type">
                                        <Select onChange={handlePaymentModeChange} placeholder="Select Payment Mode">
                                            <Option value="UPI">UPI</Option>
                                            <Option value="Cash">Cash</Option>
                                            <Option value="Cheque">Cheque</Option>
                                            <Option value="RTGS-NEFT">RTGS / NEFT</Option>
                                            <Option value="Website-Razorpay">Website - Razorpay</Option>
                                            <Option value="Application-Razorpay">Application - Razorpay</Option>
                                            <Option value="Member-Portal-Razorpay">Member Portal - Razorpay</Option>
                                            <Option value="Registration-Rozapay">Registration - Razorpay</Option>
                                        </Select>
                                    </Item>
                                </Col>
                            </Row>

                            {/* SHIKSHA NIDHI section */}
                            {showCategoryPay && (selectedBankAccount === "1" || selectedBankAccount === 1 || selectedBankAccount === "ABRSVS(SHIKSHA NIDHI)-9078(SBI)") && (
                                <>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, margin: '8px 0 16px' }}>
                                        <div style={{ flex: 1, height: 1, background: '#e8e8e8' }} />
                                        <span style={{ fontSize: 11, fontWeight: 700, color: '#1890ff', letterSpacing: 1 }}>SHIKSHA NIDHI</span>
                                        <div style={{ flex: 1, height: 1, background: '#e8e8e8' }} />
                                    </div>
                                    <Row gutter={[16, 0]}>
                                        <Col xs={24} sm={16}>
                                            <Item
                                                label="Month Coverage Period"
                                                name="month_range"
                                                rules={[
                                                    { required: true, message: 'Select the month range' },
                                                    ({ getFieldValue }) => ({
                                                        validator(_, value) {
                                                            if (!value || value.length !== 2) return Promise.reject(new Error('Please select both start and end months'));
                                                            const [start, end] = value;
                                                            if (start.isBefore(end) || start.isSame(end)) return Promise.resolve();
                                                            return Promise.reject(new Error('End month should be >= start month'));
                                                        }
                                                    })
                                                ]}
                                            >
                                                <RangePicker
                                                    picker="month"
                                                    format="MM-YYYY"
                                                    placeholder={['Start Month', 'End Month']}
                                                    style={{ width: '100%' }}
                                                    monthCellRender={monthCellRender}
                                                    popupStyle={{ zIndex: 1100 }}
                                                />
                                            </Item>
                                        </Col>
                                        <Col xs={24} sm={8}>
                                            <Item label="Monthly Share (₹)" name="month_share_amount" rules={[{ required: true, message: 'Please Enter Monthly Share' }]}>
                                                <InputNumber
                                                    className="input_number_type"
                                                    placeholder="Monthly Share"
                                                    style={{ width: '100%', fontWeight: 600 }}
                                                    min={0}
                                                    formatter={value => `₹ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                                    parser={value => value.replace(/₹\s?|(,*)/g, '')}
                                                />
                                            </Item>
                                        </Col>
                                        {isTransferMode && (
                                            <Col xs={24}>
                                                <Alert
                                                    description={newUserData ?
                                                        <Text>Verify Month Coverage and Share for <Text strong style={{ color: '#52c41a' }}>{newUserData.name_eng}</Text></Text> :
                                                        <Text type="warning">Please verify the Month Covered and Monthly Share</Text>
                                                    }
                                                    type={newUserData ? "info" : "warning"}
                                                    showIcon={false}
                                                    style={{ borderRadius: 6, marginBottom: 12 }}
                                                />
                                            </Col>
                                        )}
                                    </Row>
                                </>
                            )}

                            <Divider style={{ margin: '4px 0 20px' }} />

                            {/* Status & Remarks */}
                            <Row gutter={[16, 0]}>
                                <Col xs={24} sm={12}>
                                    <Item label="Payment Status" name="payment_virify" rules={[{ required: true, message: 'Please select status' }]}>
                                        <Select placeholder="Select Status">
                                            <Option value="pending">Pending</Option>
                                            <Option value="verified">Verified</Option>
                                            <Option value="failed">Failed</Option>
                                        </Select>
                                    </Item>
                                </Col>
                                <Col xs={24} sm={12}>
                                    <Item label="Remarks" name="remarks">
                                        <Input placeholder="Add any remarks or notes..." />
                                    </Item>
                                </Col>
                            </Row>

                            {/* Gateway Deductions — only for Razorpay modes */}
                            {showGatewayFields && (
                                <>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, margin: '8px 0 12px' }}>
                                        <div style={{ flex: 1, height: 1, background: '#ffccc7' }} />
                                        <span style={{ fontSize: 11, fontWeight: 700, color: '#f5222d', letterSpacing: 1 }}>GATEWAY DEDUCTIONS (Optional)</span>
                                        <div style={{ flex: 1, height: 1, background: '#ffccc7' }} />
                                    </div>
                                    <Row gutter={[16, 0]}>
                                        <Col xs={24} sm={8}>
                                            <Item label="Gateway Fee (₹)" name="razorpay_fee"
                                                tooltip="Razorpay commission (e.g. ₹0.22)">
                                                <InputNumber
                                                    placeholder="e.g. 0.22"
                                                    min={0} step={0.01} precision={2}
                                                    style={{ width: '100%' }}
                                                    onChange={(fee) => {
                                                        const gst = form.getFieldValue('razorpay_gst') || 0;
                                                        const amt = form.getFieldValue('amount') || 0;
                                                        form.setFieldsValue({ net_amount: parseFloat((amt - (fee || 0) - gst).toFixed(2)) });
                                                    }}
                                                />
                                            </Item>
                                        </Col>
                                        <Col xs={24} sm={8}>
                                            <Item label="GST on Fee (₹)" name="razorpay_gst"
                                                tooltip="GST on gateway commission (e.g. ₹0.04)">
                                                <InputNumber
                                                    placeholder="e.g. 0.04"
                                                    min={0} step={0.01} precision={2}
                                                    style={{ width: '100%' }}
                                                    onChange={(gst) => {
                                                        const fee = form.getFieldValue('razorpay_fee') || 0;
                                                        const amt = form.getFieldValue('amount') || 0;
                                                        form.setFieldsValue({ net_amount: parseFloat((amt - fee - (gst || 0)).toFixed(2)) });
                                                    }}
                                                />
                                            </Item>
                                        </Col>
                                        <Col xs={24} sm={8}>
                                            <Item label="Net Received (₹)" name="net_amount"
                                                tooltip="Auto-calculated: Amount − Fee − GST">
                                                <InputNumber
                                                    placeholder="Auto-calculated"
                                                    min={0} step={0.01} precision={2}
                                                    style={{ width: '100%', background: '#f6ffed' }}
                                                />
                                            </Item>
                                        </Col>
                                    </Row>
                                </>
                            )}

                            {/* E-Receipt Section */}
                            {showEReceiptFields && (
                                <>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, margin: '8px 0 16px' }}>
                                        <div style={{ flex: 1, height: 1, background: '#e8e8e8' }} />
                                        <span style={{ fontSize: 11, fontWeight: 700, color: '#722ed1', letterSpacing: 1 }}>E-RECEIPT</span>
                                        <div style={{ flex: 1, height: 1, background: '#e8e8e8' }} />
                                    </div>
                                    <Row gutter={[16, 0]}>
                                        <Col xs={24} sm={12}>
                                            <Item label="C/R-Receipt Number" name="e_reciept_no">
                                                <Input placeholder="Enter Receipt Number" style={{ fontFamily: 'monospace' }} />
                                            </Item>
                                        </Col>
                                        <Col xs={24} sm={12}>
                                            <Item label="C/R-Date">
                                                <DatePicker
                                                    onChange={handleReciptDateChange}
                                                    value={ereciept_date && ereciept_date !== '0000-00-00' && moment(ereciept_date)}
                                                    className="filter_dob"
                                                    format="DD-MM-YYYY"
                                                    placeholder="Select Date"
                                                    style={{ width: '100%' }}
                                                />
                                            </Item>
                                        </Col>
                                    </Row>
                                </>
                            )}

                            </div>{/* end scrollable body */}

                            {/* ── Footer ── */}
                            <div style={{
                                borderTop: '1px solid #e8e8e8',
                                padding: '12px 24px',
                                display: 'flex',
                                justifyContent: 'flex-end',
                                gap: 10,
                                background: '#fff'
                            }}>
                                {isDrawerMode && (
                                    <Button onClick={onClose} style={{ minWidth: 90 }}>
                                        Cancel
                                    </Button>
                                )}
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    icon={isTransferMode ? <SwapOutlined /> : <SaveOutlined />}
                                    style={isTransferMode ? {
                                        backgroundColor: '#ff4d4f', borderColor: '#ff4d4f', minWidth: 150, fontWeight: 600
                                    } : {
                                        backgroundColor: '#1e3a5f', borderColor: '#1e3a5f', minWidth: 150, fontWeight: 600
                                    }}
                                >
                                    {isTransferMode ? "Transfer Payment" : "Update Payment"}
                                </Button>
                            </div>

                        </Form>
                    </Card>
            </div>{/* end scrollable content */}

            <style jsx>{`
                @keyframes pulse {
                    0% { transform: scale(1); }
                    50% { transform: scale(1.05); }
                    100% { transform: scale(1); }
                }
                
                .ant-form-item-label > label {
                    font-weight: 500;
                    color: #434343;
                }
                
                .ant-input-affix-wrapper:focus,
                .ant-input:focus,
                .ant-select-focused .ant-select-selector {
                    border-color: #40a9ff;
                    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
                }
                
                .ant-card-head-title {
                    font-weight: 600;
                }
                
                .ant-divider-horizontal.ant-divider-with-text-left::before {
                    width: 5%;
                }
                
                .ant-btn-primary:hover {
                    transform: translateY(-1px);
                    transition: all 0.3s ease;
                }
            `}</style>
        </div>
    );
}

export default PaymentsEditForm;




